<template>
  <article class="d-flex flex-column mx-xxs-3 mt-3">
    <section class="d-flex flex-row justify-content-sm-start justify-content-between mb-2">
      <h5 class="text-align-start">
        {{ title }} {{ $t('collection.collectionCards.title', {collections: this.globalResources.collection.Plural}) }}
      </h5>
      <!-- <b-link href="/collections" class="mx-5 no-underline me-0">
        <small>{{ $t('common.more') }}</small>
      </b-link> -->
    </section>
    <CollectionsList :items="items" />
  </article>
</template>

<script>
import CollectionsList from './CollectionsList.vue'

export default {
  name: 'CollectionGroup',
  components: {
    CollectionsList
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    items: {
      type: Array,
      default: () => []
    }
  }
}
</script>
